import React, { useEffect, useRef, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCardTitle, CFormLabel, CFormSelect, CModal, CModalBody, CModalFooter, CTooltip, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import Graytextarea from '../../../components/Graytextarea'
import ProvidereGeneralExamination from '../../../components/shared/ProvidereGeneralExamination'
import PEHierarchyComponents from '../PEHierarchyComponents'
import { RichTextEditorComponent, Inject, HtmlEditor, Toolbar, QuickToolbar, Link, Image } from '@syncfusion/ej2-react-richtexteditor'
import Pageloader from '../../../components/shared/Pageloader'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'

const PhysicalExaminationRecordsFreetype = ({ isAllotedToProvider = false, patientDBdata, isSavingTheData, patientID, MasterDiagnosisData, loggedUserProvider, setPatientDBdata, noteID, noteCallType = "/provider/pre-signed" }) => {
    const [physicalExaminationData, setPhysicalExaminationData] = useState([])
    const [generalExaminationData, setGeneralExaminationData] = useState([])
    const [diagnosisExaminationData, setDiagnosisExaminationData] = useState([])
    const [visible, setVisible] = useState(false)
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    // const [patientDiagnosis, setPatientDiagnosis] = useState([])
    const [globalRemarkText, setGlobalRemarkText] = useState('')
    const [globalRemarkTextToShow, setGlobalRemarkTextToShow] = useState('')
    const [tempGlobalRemarkText, setTempGlobalRemarkText] = useState('')
    const [showGlobalRemarkModal, setShowGlobalRemarkModal] = useState(false)
    const [updatePatientDiagnosis, setUpdatePatientDiagnosis] = useState({})
    const [updateOfflineStructure, setUpdateOfflineStructure] = useState({})
    const [patientDiagnosis, setPatientDiagnosis] = useState([])
    const [addedThruUseeffect, setAddedThruUseEffect] = useState(false)
    const [finalHtml, setFinalHtml] = useState('')

    useEffect(() => {
    if (!finalHtml && !globalRemarkText) return;

    if (addedThruUseeffect) {
        setAddedThruUseEffect(false)
        return;
    }

    setPatientDBdata((prev) => {
        const peChanges = {
            html: finalHtml,
            globalRemarkText: globalRemarkText,
        };

        return {
            ...prev,

            // update current note
            currentNote: {
                ...prev.currentNote,
                data: {
                    ...prev.currentNote?.data,
                    freeTypesEverything: {
                        ...prev.currentNote?.data?.freeTypesEverything,
                        peChanges,
                    },
                },
            },

            // update allNotes array
            allNotes: prev.allNotes?.map((note) => {
                if (note.id === prev.currentNote?.id) {
                    const parsedData = note.data ? JSON.parse(note.data) : {};

                    return {
                        ...note,
                        data: JSON.stringify({
                            ...parsedData,
                            freeTypesEverything: {
                                ...parsedData?.freeTypesEverything,
                                peChanges,
                            },
                        }),
                    };
                }
                return note;
            }),
        };
    });
    setAddedThruUseEffect(true)
}, [finalHtml, globalRemarkText]);


    useEffect(() => {
        const patientD = patientDBdata?.patientData?.Diagnosis?.split(',')
        setPatientDiagnosis(patientD)
    }, [])


    const { getPEData, getOfflineData, getProviderDetails, saveOfflineData, getOpenChartOfflineData, saveOpenChartOfflineData, } = useIndexedDB()
    const fetchPEdata = async () => {
        const data = await getPEData()

        setDiagnosisExaminationData(data?.Diagnosis)
        setGeneralExaminationData(data?.General)
    }
    const getGeneralExaminationData = async () => {


        try {
            let data = await SaveExtra('Get_By_Type', 'PhysicalExaminationDummyData', '', '')
            data = JSON.parse(data.d)?.Data || []

            if (data) {
                data = data?.map((item) => {
                    return {
                        Id: item.Id,
                        Data: JSON.parse(item?.JsonData),
                    }
                })
            }

            setGeneralExaminationData(data[0]?.Data)


        } catch (error) {

            // toast.error('Failed to fetch data', toastConfig)
        } finally {
        }
    }

    const getDiagnosisExaminationData = async () => {
        try {
            let data = await SaveExtra('Get_By_Type', 'DiagnosisExaminationDummyData', '', '')
            data = JSON.parse(data.d)?.Data || []

            if (data) {
                data = data?.map((item) => {
                    return {
                        Id: item.Id,
                        Data: JSON.parse(item?.JsonData),
                    }
                })
            }
            let diagnosisQestion = data[0]?.Data

            diagnosisQestion = diagnosisQestion.filter((item) => patientDiagnosis.includes(item.name.trim()))


            setDiagnosisExaminationData(data[0]?.Data)
        } catch (error) {

            // toast.error('Failed to fetch data', toastConfig)
        } finally {

        }
    }


    const fetchData = async () => {
        setIsPageLoading(true)
        let lastGeneralExamination = []
        let lastLastDiagnosisExamination = []
        // let response = await PatientPhysicalExaminationData('Get_By_Patient', patientID)
        // const parsedData = JSON.parse(response.d).Data || []


        //    const data = noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
        //    const loggedUserID = await getProviderDetails()
        //    const PEData = data[loggedUserID?.ID] || []
        const parsedData = patientDBdata.PEPatientData || []

        const findLastDiagnosisExaminationData = parsedData.filter((item) => item.Type === 'DiagnosisExaminationData' && item?.NoteID === noteID?.toString()) || []
        const findLastGeneralDiagnosisExamination = parsedData.filter((item) => item.Type === 'GeneralExaminationData' && item?.NoteID === noteID?.toString()) || []

        const globalRemarks = parsedData.filter((item) => item.Type === "PhysicalExaminationGlobalRemark" && item?.NoteID === noteID?.toString());

        const lastGlobalRemark = globalRemarks[globalRemarks.length - 1] || null;

        const jsonRemarkGlobalRemark = lastGlobalRemark
            ? JSON.parse(lastGlobalRemark.JsonData)
            : null;

        // if (findLastGeneralDiagnosisExamination.length > 0) {
        //     lastGeneralExamination = JSON.parse(findLastGeneralDiagnosisExamination[findLastGeneralDiagnosisExamination.length - 1]?.JsonData) || []
        // setPhysicalExaminationData([...lastLastDiagnosisExamination])
        // }
        // if (findLastDiagnosisExaminationData.length > 0) {
        //     lastLastDiagnosisExamination = JSON.parse(findLastDiagnosisExaminationData[findLastDiagnosisExaminationData.length - 1]?.JsonData) || []
        //     setPhysicalExaminationData([...lastGeneralExamination])
        // }

        setGlobalRemarkTextToShow(jsonRemarkGlobalRemark?.globalRemarkText || "")
        setTempGlobalRemarkText(jsonRemarkGlobalRemark?.globalRemarkText || '')
        setGlobalRemarkText(jsonRemarkGlobalRemark?.globalRemarkText || '')

        if (findLastGeneralDiagnosisExamination.length > 0) {
            const parsedGeneral = JSON.parse(findLastGeneralDiagnosisExamination[findLastGeneralDiagnosisExamination.length - 1]?.JsonData)
            lastGeneralExamination = Array.isArray(parsedGeneral) ? parsedGeneral : []


            setGeneralExaminationData(lastGeneralExamination)
        } else {
            // getGeneralExaminationData()
            fetchPEdata()
        }
        // Parse and set diagnosis examination data
        if (findLastDiagnosisExaminationData.length > 0) {
            const parsedDiagnosis = JSON.parse(findLastDiagnosisExaminationData[findLastDiagnosisExaminationData.length - 1]?.JsonData)

            lastLastDiagnosisExamination = Array.isArray(parsedDiagnosis) ? parsedDiagnosis : []
            setDiagnosisExaminationData(lastLastDiagnosisExamination)
        } else {
            // getDiagnosisExaminationData()
            fetchPEdata()
        }

        setPhysicalExaminationData([...lastGeneralExamination, ...lastLastDiagnosisExamination])
        setIsPageLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [])

    const [renderData, setRenderData] = useState(null)
    const [count, setCount] = useState(1)
    const [formattedOutput, setFormattedOutput] = useState('')
    const formatDataForAPI = (data) => {
        let output = ''
        let parsedData = data
        // try {
        //     parsedData = JSON.parse(data);
        // } catch (error) {
        //     console.error("Error parsing data:", error);
        //     return "";
        // }
        // Filter accordions
        const accordions = parsedData.filter((item) => item.type === 'accordion')
        // Format the accordions
        output += 'General Examination\n'
        accordions.forEach((accordion) => {
            if (accordion.isSelected || (accordion.hierarchy && accordion.hierarchy.some((child) => child.isSelected))) {
                output += `  ${accordion.name}\n`
                // Format hierarchy items
                accordion.hierarchy.forEach((headerItem) => {
                    if (headerItem.isSelected) {
                        output += `    ${headerItem.name.split('-')[0]}\n`
                        // Format any children
                        if (headerItem.hierarchy && headerItem.hierarchy.length > 0) {
                            formatHierarchyItems(headerItem.hierarchy, output, 6)
                        }
                        // Add input data if present
                        if (headerItem.inputData) {
                            output += `      ${headerItem.inputData}\n`
                        }
                    }
                })
            }
        })
        return output
    }
    const formatHierarchyItems = (items, outputString, indentLevel) => {
        if (!items || !items.length) return outputString
        items.forEach((item) => {
            if (item.isSelected) {
                const indent = ' '.repeat(indentLevel)
                const itemName = item.name.split('-')[0]
                if (item.type === 'subHeader') {
                    outputString += `${indent}${itemName}: `
                    // If this subheader has selected children, add them inline
                    const selectedChildren = item.hierarchy?.filter((child) => child.isSelected) || []
                    if (selectedChildren.length > 0) {
                        const childrenText = selectedChildren.map((child) => child.name.split('-')[0]).join(', ')
                        outputString += `${childrenText}`
                    } else {
                        outputString += '\n'
                    }
                } else {
                    outputString += `${indent}${itemName}\n`
                }
                // Add input data if present
                if (item.inputData) {
                    outputString += `${indent}  Reason: ${item.inputData}\n`
                }
                // Recursively format children with increased indentation
                if (item.hierarchy && item.hierarchy.length > 0 && item.type !== 'subHeader') {
                    // Skip children that were already processed inline
                    formatHierarchyItems(item.hierarchy, outputString, indentLevel + 2)
                }
            }
        })
        return outputString
    }
    const RenderHierarchy = ({ item }) => {
        if (!item.hierarchy || item.hierarchy.length === 0) {
            return item.isSelected == true ? (
                <>
                    <span className="">{item.name.split('-')[0]}</span>
                    {item?.inputData && <span className=" ms-2">Reason : {item?.inputData?.split('-')[0]}</span>}
                </>
            ) : null
        }
        return (
            <div
                className={`d-flex ${item.type === 'title' || item.type === 'option' ? 'flex-column' : 'flex-row'}`}
                style={{
                    fontWeight: item.type === 'title' || item.type === 'header' ? '700' : '500',
                }}
            >
                <span className="">{item.name.split('-')[0]}</span>
                {item.hierarchy.map((child, index) => (
                    <RenderHierarchy key={index} item={child} />
                ))}
            </div>
        )
    }
    const convertToHTML = (item, tabCount = 0, parent) => {
        const indent = ''
        let html = ''
        if (!item.hierarchy || item.hierarchy.length === 0) {
            if (item.isSelected) {
                const parts = item.name.split('-')[0]
                html += `${indent}${parts}, `
                if (item.name.split('-')[0] === 'Unable to test' && item.inputData) {
                    html += `  (Reason - ${item.inputData})  <br/>`
                }
            }
            return html
        }
        if (!item.isSelected) return ''
        if (item.type === 'header') {
            html += `<br/><b>${indent}${item.name.split('-')[0]}</b> `
        } else if (item.type === 'subHeader') {
            if (parent?.type === 'header' && parent?.hierarchyType !== 'multi') {
                html += `<br/>`
            }
            html += ` - <i> <u> ${indent}${item.name.split('-')[0]}</u>:&nbsp</i>`
        }
        if (item.type === 'option') {
            html += `<span>${indent}${item.name.split('-')[0]}</span>, `
        }
        if (item.inputData) {
            html += `${indent}<span style="color: gray;">(${item.inputData})</span><br/>`
        }
        item.hierarchy.forEach((child) => {
            html += convertToHTML(child, tabCount + 1, item)
        })
        return html
    }
    // const RenderAccordion = ({ item }) => {
    //     if (!item.isSelected && !item.hierarchy.some(child => child.isSelected)) {
    //         return null;
    //     }
    //     return (
    //         <div >
    //             <div className=" fw-bold " style={{ fontSize: "16px", textDecoration: "underline" }}>
    //                 {item.name}
    //             </div>
    //             {item.hierarchy.map((bodyItem, idx) => (
    //                 <div key={idx} className="d-flex">
    //                     <RenderOption item={bodyItem} parent={item} tabCount={1} />
    //                 </div>
    //             ))}
    //         </div>
    //     );
    // };
    // inside a component
    const RenderAccordion = ({ item }) => {
        if (!item.isSelected && !item.hierarchy.some((child) => child.isSelected)) return null
        let finalHtml = `<b>${item.name}</b><br/>`
        item.hierarchy.forEach((bodyItem) => {
            finalHtml += convertToHTML(bodyItem)
        })
    }
    // Adding the physical exmaination data
    useEffect(() => {
        if (physicalExaminationData) {
            setRenderData(physicalExaminationData)
            const formatted = formatDataForAPI(physicalExaminationData)
            setFormattedOutput(formatted)
            const html = physicalExaminationData
                .filter((item) => item.type === 'accordion' && (item.isSelected || item.hierarchy?.some((child) => child.isSelected)))
                .map((item) => {
                    let sectionHtml = `<b style="font-size:16px; text-decoration:underline;">${item.name}</b><br/> `
                    item.hierarchy.forEach((bodyItem) => {
                        sectionHtml += convertToHTML(bodyItem, 1, item)
                    })
                    return sectionHtml
                })
                .join('<br/> ')
            const cleanedHtml = html
                .replace(/(<br\/?>\s*){2,}/g, '<br/>')
                .replace(/^(<br\/?>)+/, '')
                .replace(/(<br\/?>)+$/, '')
            setFinalHtml(cleanedHtml)
        }
    }, [physicalExaminationData])




    const handleAddPeOffline = async () => {
        try {
            let patientData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()

            const loggedUserID = await getProviderDetails()
            //  put the data at same place of patientID.pedpatientdata
            // patientData = {
            //   ...patientData,
            //   [loggedUserID?.ID]: {
            //     ...patientData[loggedUserID?.ID],
            //     [patientID]: {
            //       ...patientData[loggedUserID?.ID][patientID],
            //       PEPatientData:

            //         [
            //           {
            //             patientID:patientID?.toString(),
            //             NoteID:noteID?.toString(),
            //             Type:'GeneralExaminationData',
            //             JsonData:JSON.stringify(generalExaminationData),
            //             toBeInserted: true
            //           },
            //           {
            //             patientID:patientID?.toString(),
            //             NoteID:noteID?.toString(),
            //             Type:'DiagnosisExaminationData',
            //             JsonData:JSON.stringify(diagnosisExaminationData),
            //             toBeInserted: true
            //           }
            //         ]
            //     }
            //   }
            // }
            patientData = {
                ...patientData,
                [loggedUserID?.ID]: {
                    ...patientData[loggedUserID?.ID],
                    [patientID]: {
                        ...patientData[loggedUserID?.ID][patientID],

                        PEPatientData: [
                            ...(patientData[loggedUserID?.ID][patientID]?.PEPatientData || [])
                                .filter(
                                    (item) =>
                                        item.Type !== "GeneralExaminationData" &&
                                        item.Type !== "DiagnosisExaminationData"
                                ),

                            {
                                patientID: patientID?.toString(),
                                NoteID: noteID?.toString(),
                                Type: "GeneralExaminationData",
                                JsonData: JSON.stringify(generalExaminationData),
                                toBeInserted: true,
                            },

                            {
                                patientID: patientID?.toString(),
                                NoteID: noteID?.toString(),
                                Type: "DiagnosisExaminationData",
                                JsonData: JSON.stringify(diagnosisExaminationData),
                                toBeInserted: true,
                            },
                        ],
                    },
                },
            };

            setPatientDBdata((p) => {
                const filtered = (p.PEPatientData || []).filter(
                    item => item.Type !== 'GeneralExaminationData' &&
                        item.Type !== 'DiagnosisExaminationData'
                )


                return {
                    ...p,
                    PEPatientData: [
                        ...filtered,
                        {
                            patientID: patientID?.toString(),
                            NoteID: noteID?.toString(),
                            Type: 'GeneralExaminationData',
                            JsonData: JSON.stringify(generalExaminationData),
                            toBeInserted: true
                        },
                        {
                            patientID: patientID?.toString(),
                            NoteID: noteID?.toString(),
                            Type: 'DiagnosisExaminationData',
                            JsonData: JSON.stringify(diagnosisExaminationData),
                            toBeInserted: true
                        }
                    ]
                }
            })
            noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(patientData) : await saveOfflineData(patientData)


        } catch (error) {
        }
        finally {
            setPEAdded(p => !p)
        }
    }

    const handleSave = async () => {
        setIsPageLoading(true)
        const addPE = async (type, data) => {
            try {

                let response = await PatientPhysicalExaminationData('Insert', patientID, noteID, type, JSON.stringify(data))
            } catch (error) {
                toast.error('Failed to save General Examination Data', toastConfig)
                console.error('Error saving General Examination Data:', error)
            } finally {
                setIsPageLoading(false)
            }
        }

        // await addPE('GeneralExaminationData', generalExaminationData)
        // await addPE('DiagnosisExaminationData', diagnosisExaminationData)
        await handleAddPeOffline()
        toast.success('Physical Examination Data saved successfully', toastConfig)
        await fetchData()
        setVisible(false)
        setIsSaving(false)
    }

    // const getPatientDiagnosis = async () => {
    //   let diagnosisData = await ModifyPatientMap('GETALL', patientID, '')

    //   let tempData = JSON.parse(diagnosisData.d)?.Data

    //   diagnosisData = tempData.filter((obj) => {
    //     if (patientID == obj.PatientID) {
    //       return obj
    //     }
    //   })
    //   
    //   let patientD = []
    //   try {
    //     patientD = diagnosisData[0]?.Diagnosis?.split(',')

    //     // setPatientDiagnosis(patientD)
    //     
    //   } catch (e) { }
    // }
    // useEffect(() => {
    //   getPatientDiagnosis()
    // }, [visible])

    const userData = JSON.parse(localStorage.getItem('user'))
    const role = userData?.Role

    

    const handleAddPeGlobalRemarkOffline = async () => {
        try {


            // Filter out existing PhysicalExaminationGlobalRemark
            const filteredPEData = patientDBdata?.PEPatientData.filter(
                (item) => item.Type !== 'PhysicalExaminationGlobalRemark'
            )

            const updatedPEData = [
                ...filteredPEData,
                {
                    patientID: patientDBdata?.details?.PatientID?.toString(),
                    NoteID: noteID?.toString(),
                    Type: 'PhysicalExaminationGlobalRemark',
                    JsonData: JSON.stringify({ globalRemarkText: tempGlobalRemarkText }),
                    toBeInserted: true,
                },
            ]
            

            setPatientDBdata((p) => ({
                ...p,
                PEPatientData: updatedPEData
            }))


        } catch (error) {
            console.error('Error in handleAddPeGlobalRemarkOffline:', error)
        }
    }

    const handleAddGlobalRemarkPE = async () => {
        // const a = await add
        // setGlobalRemarkText(tempGlobalRemarkText)
        await handleAddPeGlobalRemarkOffline()
    }


    const handleUpdateMasterData = async () => {
        try {
            if (
                Object.keys(updatePatientDiagnosis || {}).length) {

                // noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(updateOfflineStructure) : await saveOfflineData(updateOfflineStructure)
                await setPatientDBdata(updatePatientDiagnosis)

                if (!patientDiagnosis.includes('Tremor')) {
                    setPatientDiagnosis((prev) => [...prev, 'Tremor'])
                }
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        fetchPEdata()
    }, [])

    const divRef = useRef(null);
    const initialHtmlRef = useRef("");
const initialGlobalRemarkRef = useRef("");

    // const handleFocus = () => {
    //     initialHtmlRef.current = divRef.current.innerHTML;
    // };
    const handleFocus = () => {
  initialHtmlRef.current = divRef.current.innerHTML;
  initialGlobalRemarkRef.current = tempGlobalRemarkText;
};



    const handleAddHtmlPe = async () => {
        // Filter out existing PhysicalExaminationGlobalRemark
        const filteredPEData = patientDBdata?.PEPatientData.filter(
            (item) => item.Type !== 'PhysicalExaminationEditedHtml'
        )

        const updatedPEData = [
            ...filteredPEData,
            {
                patientID: patientDBdata?.details?.PatientID?.toString(),
                NoteID: noteID?.toString(),
                Type: 'PhysicalExaminationEditedHtml',
                JsonData: JSON.stringify({ html: divRef.current.innerHTML }),
                toBeInserted: true,
            },
        ]
        

        setPatientDBdata((p) => ({
            ...p,
            PEPatientData: updatedPEData
        }))
    }


    // const handleBlur = () => {
    //     const updatedHtml = divRef.current.innerHTML;

    //     if (initialHtmlRef.current === updatedHtml) {
    //         
    //     } else {

    //     }
    // };

    if (!globalRemarkText && !finalHtml) { return null }

    const handleBlur = () => {
        const updatedHtml = divRef.current.innerHTML;
        const updatedGlobalRemark = tempGlobalRemarkText;

        const isHtmlChanged = initialHtmlRef.current !== updatedHtml;
        const isRemarkChanged = initialGlobalRemarkRef.current !== updatedGlobalRemark;

        

        if (!isHtmlChanged && !isRemarkChanged) {
            return;
        }


        setPatientDBdata((prev) => {
            const peChanges = {
                html: updatedHtml,
                globalRemarkText: updatedGlobalRemark,
            };

            
            return {
                ...prev,

                currentNote: {
                    ...prev.currentNote,
                    data: {
                        ...prev.currentNote?.data,
                        freeTypesEverything: {
                            ...prev.currentNote?.data?.freeTypesEverything,
                            peChanges,
                        },
                    },
                },

                allNotes: prev.allNotes?.map((note) => {
                    if (note.id === prev.currentNote?.id) {
                        const parsedData = note.data ? JSON.parse(note.data) : {};

                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                freeTypesEverything: {
                                    ...parsedData?.freeTypesEverything,
                                    peChanges,
                                },
                            }),
                        };
                    }
                    return note;
                }),
            };
        });
    };


    

    return (
        <div className='d-flex align-items-start '>
            <div style={{ minWidth: "23%" }}>Physical Examination</div>
            <div className='w-100'>
                <div className="d-flex flex-column gap-4">


                    <div className="ProviderPhysicalExaminationTab">
                        {isPageLoading ? (
                            // <div className="p-4">
                            //   <CSpinner size="sm" className="me-2" />
                            //   Loading...
                            // </div>
                            <Pageloader isLoading={isPageLoading} />
                        ) : (
                            <>
                                {finalHtml ? (
                                    <div className="mt-2  PhysicalExaminationVisualNote" style={{}}>
                                        <div
                                            ref={divRef}
                                            contentEditable
                                            suppressContentEditableWarning
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            dangerouslySetInnerHTML={{ __html: finalHtml }}
                                            style={{ background: "#8080800d", padding: "8px" }}
                                        />
                                    </div>
                                ) :
                                    globalRemarkText ?
                                        ""
                                        :
                                        (
                                            <div className="d-flex justify-content-center p-8 align-items-center text-muted" style={{ height: '50px' }}>
                                                <div
                                                    style={{
                                                        fontSize: '15px',
                                                        fontWeight: '600px',
                                                        color: 'gray',
                                                    }}
                                                >
                                                    No Physical Examination
                                                </div>
                                            </div>
                                        )}
                            </>
                        )}
                    </div>

                    <div>
                        {globalRemarkText &&
                            <GraytextareaAdjustable
                                onBlur={handleBlur}
                                value={tempGlobalRemarkText}
                                  onFocus={handleFocus}
                                onChange={(e) => setTempGlobalRemarkText(e.target.value)}
                            />}
                    </div>


                </div>
            </div>
        </div>
    )
}

export default PhysicalExaminationRecordsFreetype